export const iconFontAwesomeTravelHotelSleigh = (
	<i className="fa-solid fa-sleigh"></i>
);
